import { render } from "./EditAuthForm.vue?vue&type=template&id=c3a53580&ts=true"
import script from "./EditAuthForm.vue?vue&type=script&lang=ts"
export * from "./EditAuthForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__